<template>
  <div class="body_right">
    <div class="body_right_first">
      <div class="img"><img src="@/assets/imgs/icon_open.png"></div>
      <div class="title">記事管理</div>
    </div>
    <div class="body_right_second">
      <el-button style="width: 152px;" type="primary" @click="addDialog = true"><i class="el-icon-plus"></i>&nbsp;&nbsp;記事を投稿</el-button>
      <el-button style="width: 130px;" @click="fetch"><i class="el-icon-refresh-right"></i>&nbsp;&nbsp;更新</el-button>
    </div>
    <div class="body_right_third">
      <div style="padding: 15px 26px;">
        <div class="body_right_third_head">
          <div class="head_title">タイトル:<div class="input"><el-input v-model="searchFrom.title" placeholder="Title"/></div></div>
          <div class="head_title">タグ:
            <div class="input"><el-select multiple :multiple-limit="1" style="width: 150px;" v-model="searchFrom.articleTagIds" placeholder="请选择">
              <el-option
                v-for="item in articleTagsList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                style="width: 150px;">
              </el-option>
            </el-select></div>
          </div>
          <div class="head_title">ステータス:
            <div class="input"><el-select v-model="searchFrom.state" placeholder="请选择">
              <el-option
                v-for="item in sortOptions"
                :key="item.key"
                :label="item.label"
                :value="item.key">
              </el-option>
            </el-select></div>
          </div>
          <div class="head_title"><el-button style="background-color: #FF6633;color: #FFFFFF;width: 94px;border:0;" @click="getList()"><i class="el-icon-search"></i>&nbsp;&nbsp;検索</el-button></div>
        </div>
        <div class="body_right_third_scrollbar">
          <el-table
            ref="singleTable"
            border
            :data="list"
            v-loading="Loading"
            highlight-current-row
            height="670px"
            @current-change="handleCurrentChange"
            :default-sort = "{prop: 'date', order: 'descending'}"
            style="width: 100%;">
            <el-table-column type="index" label="ID" align="center"width="50">
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="180">
              <template slot-scope="{ row }">
                <el-button type="primary" @click="openArticle(row.id)">レピューを見る</el-button>
              </template>
            </el-table-column>
            <el-table-column property="creator.nickname" label="投稿者" align="center" width="120">
            </el-table-column>
            <el-table-column property="createdDate" label="投稿时间" align="center" width="180">
              <template slot-scope="{ row }">
                {{getTime(row.createdDate)}}
              </template>
            </el-table-column>
            <el-table-column property="title" label="タイトル" align="center" width="230">
            </el-table-column>
            <el-table-column property="state" label="ステータス" align="center" width="80">
              <template slot-scope="{ row }">
                {{row.state == "NORMAL"?"正常":"审核中"}}
              </template>
            </el-table-column>
            <el-table-column label="「いいね！」の数" min-width="100" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.likeNum }}</span>
              </template>
            </el-table-column>
            <el-table-column label="閲覧数" min-width="80" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.readNum }}</span>
              </template>
            </el-table-column>
            <el-table-column label="シェアの数" min-width="100" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.shareNum }}</span>
              </template>
            </el-table-column>
            <el-table-column label="地域" min-width="110" align="center">
              <template slot-scope="{ row }">
                <span v-if="row.areaId">
                  <span v-for="n in areaList" :value="n.name">{{
                    n.id == row.areaId ? n.name : ""
                  }}</span>
                </span>
                <span v-else>无</span>
              </template>
            </el-table-column>
            <el-table-column label="表紙" min-width="160" align="center">
              <template slot-scope="{ row }">
                <span v-if="row.images">
                  <img
                    v-for="n in row.images"
                    :key="n"
                    :src="n"
                    style="width: 50px; height: 50px"
                  />
                </span>
                <span v-else>无</span>
              </template>
            </el-table-column>
            <el-table-column label="内容" min-width="60" align="center">
              <template slot-scope="{ row }">
                <i
                  class="el-icon-view"
                  @click="lockcontent(row.title, row.content)"
                />
              </template>
            </el-table-column>
            <el-table-column label="タグ" min-width="60" align="center">
              <template slot-scope="{ row }">
                <i class="el-icon-view" @click="locktag(row.id)" />
                <span></span>
              </template>
            </el-table-column>
          </el-table>
          <div class="table_pagination">
            <pagination
              :total="total"
              :page.sync="page"
              :limit.sync="size"
              @pagination="getList"
            />
          </div>
        </div>
      </div>
    </div>
    <add-article v-if="addDialog" :addDialog.sync="addDialog" :articleTagsList="articleTagsList"></add-article>
  </div>
</template>

<script>
  import * as json from '@/assets/js/json'
  import {previewHtml,getTime} from '@/assets/js/util'
  import addArticle from '@/pages/homePage/manage/articleManage/addArticle'
  import Pagination from "@/components/Pagination"; 
  export default {
    components: {
      addArticle,
      Pagination,
      
    },
    data () {
      return {
        list: [],
        articleTagsList:[],
        areaList:[],
        sortOptions: [
          { label: "全部", key: null },
          { label: "正常", key: "NORMAL" },
          { label: "審査中", key: "AUDITING" },
        ],
        searchFrom: {
          title: null,
          articleTagIds: null,
          state: null,
          type: 'common',
        },
        addDialog: false,
        page: 1,
        size: 10,
        total: 0,
        Loading: false
      }
    },
    created () {
      this.fetch()
    },
    methods: {
      fetch(){
        this.searchFrom = {
          title: null,
          articleTagIds: null,
          state: null,
          type: 'common',
        }
        this.getArticleTags()
        this.getList()
        this.getArea()
      },
      getList(){
        this.Loading = true
        let Option= this.searchFrom
        json.uploadPost('/api/userSystem/article/list/'+this.page+'/'+this.size, Option).then((res) => {
          if (res.data.success) {
            this.list = res.data.data.list.records
            this.total = res.data.data.list.total
            this.Loading = false
          }
        })
      },
      getArticleTags(){
        json.uploadPost('/api/member/article/create?type=COMMON').then((res) => {
          if (res.data.success) {
            this.articleTagsList = res.data.data.articleTags
          }
        })
      },
      getArea(){
        json.uploadPost('/api/member/index/area_fetch').then((res) => {
          if (res.data.success) {
            this.areaList = res.data.data.areas
          }
        })
      },
      lockcontent(title, content) {
        previewHtml(title, content);
      },
      openArticle(id){
        this.$router.push('/article?articleId=' + id)
      },
      locktag(id) {
        json.uploadPost('/api/userSystem/article/tag/list/'+id).then((res) => {
          if (res.data.success) {
            this.articleTags = res.data.articleTags;
            this.dialogPvVisible = true;
          }
        })
      },
      handleSizeChange(){
        
      },
      handleCurrentChange(){

      },
      getTime(timestamp){
        return getTime(timestamp);
      }
    }
  }
</script>

<style src="@/pages/homePage/manage/index.css" scoped>
</style>

